// import Footer from './Footer';
// import UserMarket from '../UserMarket';
import { useAppDispatch, useAppSelector } from '@/state/hooks';
import { selectShowOverlay, setShowOverlay } from '@/state/reducers/generalSlice';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import { useScreenSizes } from '@/utils/providers/ScreenSizesProvider';
import cn from 'classnames';
import { Fragment, useMemo, useState } from 'react';
import MobileModuleTabs from './MobileModuleTabs';
import MobileSubHeader from './MobileSubHeader';
import MobileTraderModuleTabs from './MobileTraderModuleTabs';
import Navbar from './Navbar';
import UniversalSidebar from './UniversalSidebar';

interface LayoutProps extends React.PropsWithChildren {
    prevPath: string | null;
}

export default function Layout({ prevPath, children }: LayoutProps) {
    const dispatch = useAppDispatch();
    const pathname = window.location.pathname;

    const showOverlay = useAppSelector(selectShowOverlay);

    const settings = useDisclosure(false);
    const { mobile, tablet } = useScreenSizes();

    const [isExpanded, setIsExpanded] = useState(
        prevPath?.includes('/portal') || prevPath?.includes('/lite') ? true : false
    );

    const isMobile = useMemo(() => mobile || tablet, [mobile, tablet]);

    const width = useMemo(() => {
        if (isMobile) {
            return '100%';
        } else {
            return isExpanded ? 'calc(100% - 257px)' : 'calc(100% - 61px)';
        }
    }, [isExpanded, isMobile]);

    const marginLeft = useMemo(() => {
        if (isMobile) {
            return 0;
        } else {
            return isExpanded ? 257 : 61;
        }
    }, [isExpanded, isMobile]);

    return (
        <div className="relative flex flex-col border-t-[1.5px] lg:border-t-[3px] border-brand-border">
            <UniversalSidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} settingsDisclosure={settings} />
            <div
                className={cn('flex flex-col', {
                    'transition-all duration-200 bg-brand-background': !isMobile
                })}
                style={{ width, marginLeft, direction: 'ltr' }}>
                <Navbar settings={settings} />
                {isMobile && (
                    <Fragment>
                        {pathname.includes('trader') ? <MobileTraderModuleTabs /> : <MobileModuleTabs />}
                    </Fragment>
                )}
                <main className="relative trading-layout">{children}</main>
                <MobileSubHeader />
            </div>
            {showOverlay && (
                <div
                    className={cn('fixed inset-0 w-screen h-screen bg-black bg-opacity-50 z-[100]')}
                    onClick={() => dispatch(setShowOverlay(false))}
                />
            )}
        </div>
    );
}
